import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export default function LoginPage() {
  const [form,    setForm]    = useState({ email: '', password: '' });
  const [loading, setLoading] = useState(false);
  const [error,   setError]   = useState('');
  const { login, blockedMsg, setBlockedMsg } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    setBlockedMsg?.(null);
    try {
      await login(form.email, form.password);
      navigate('/dashboard');
    } catch (err) {
      const msg = err.response?.data?.error || 'Login failed. Please check your credentials.';
      setError(msg);
    } finally {
      setLoading(false);
    }
  };

  const displayError = blockedMsg || error;
  const isBlocked = !!(blockedMsg || (error && (error.toLowerCase().includes('block') || error.toLowerCase().includes('no exam'))));
  const isNoExam = error && error.toLowerCase().includes('no exam assigned');

  return (
    <div className="auth-page">
      <div className="auth-card">
        <div style={{ textAlign:'center', marginBottom:28 }}>
          <div className="logo-text" style={{ fontSize:28, marginBottom:4 }}>⬡ ExamAI</div>
          <div style={{ fontSize:12, color:'var(--text-muted)', fontFamily:'var(--font-mono)' }}>PROCTORED ASSESSMENT PLATFORM</div>
        </div>

        {/* Error / blocked message */}
        {displayError && (
          <div style={{
            padding:'14px 16px', borderRadius:10, marginBottom:20,
            background: isBlocked ? 'rgba(239,68,68,0.1)' : 'rgba(239,68,68,0.08)',
            border: `1px solid ${isBlocked ? 'var(--accent-danger)' : 'rgba(239,68,68,0.3)'}`,
          }}>
            {isNoExam ? (
              <>
                <div style={{ fontWeight:700, fontSize:14, color:'var(--accent-warning)', marginBottom:6 }}>
                  📋 No Exam Assigned
                </div>
                <div style={{ fontSize:13, color:'var(--text-secondary)', lineHeight:1.6 }}>
                  {displayError}
                </div>
                <div style={{ fontSize:12, color:'var(--text-muted)', marginTop:8 }}>
                  Contact your organization or admin to get assigned to an exam.
                </div>
              </>
            ) : isBlocked ? (
              <>
                <div style={{ fontWeight:700, fontSize:14, color:'var(--accent-danger)', marginBottom:6 }}>
                  ⛔ Access Blocked
                </div>
                <div style={{ fontSize:13, color:'var(--accent-danger)', lineHeight:1.6 }}>
                  {displayError}
                </div>
                <div style={{ fontSize:12, color:'var(--text-muted)', marginTop:8 }}>
                  Contact: <strong>support@examai.com</strong>
                </div>
              </>
            ) : (
              <div style={{ fontSize:13, color:'var(--text-secondary)', lineHeight:1.6 }}>
                {displayError}
              </div>
            )}
          </div>
        )}

        <p style={{ fontSize:16, fontWeight:600, marginBottom:20, color:'var(--text-secondary)' }}>Sign in to your account</p>

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label className="form-label">Email Address</label>
            <input className="form-input" type="email" value={form.email}
              onChange={e => { setForm(p=>({...p, email:e.target.value})); setError(''); setBlockedMsg?.(null); }}
              placeholder="you@example.com" required autoFocus />
          </div>
          <div className="form-group">
            <label className="form-label">Password</label>
            <input className="form-input" type="password" value={form.password}
              onChange={e => { setForm(p=>({...p, password:e.target.value})); setError(''); }}
              placeholder="••••••••" required />
          </div>
          <button className="btn btn-primary w-full btn-lg" type="submit" disabled={loading}
            style={{ justifyContent:'center', marginTop:8 }}>
            {loading ? 'Signing in...' : 'Sign In →'}
          </button>
        </form>

        <div style={{ textAlign:'center', marginTop:20, fontSize:14, color:'var(--text-secondary)' }}>
          No account? <Link to="/register" style={{ color:'var(--accent-primary)' }}>Register here</Link>
        </div>

      </div>
    </div>
  );
}
